import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './assets/css/index.scss'

ReactDOM.render(<App/>, document.getElementById('live-anzeige'));
